import { render, staticRenderFns } from "./JoinRoundIcon.vue?vue&type=template&id=35b2a0a0&"
import script from "./JoinRoundIcon.vue?vue&type=script&lang=js&"
export * from "./JoinRoundIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports